import { render, staticRenderFns } from "./StatisticsPage.vue?vue&type=template&id=3243afec&"
import script from "./StatisticsPage.vue?vue&type=script&lang=js&"
export * from "./StatisticsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3243afec')) {
      api.createRecord('3243afec', component.options)
    } else {
      api.reload('3243afec', component.options)
    }
    module.hot.accept("./StatisticsPage.vue?vue&type=template&id=3243afec&", function () {
      api.rerender('3243afec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/statistics/StatisticsPage.vue"
export default component.exports